export const STAGES = [
    {
        id: 'sales',
        name: 'Sales',
        subLabels: ['Lead Awareness', 'Interest', 'Decision', 'Action', 'Expand']
    },
    {
        id: 'delivery',
        name: 'Delivery',
        subLabels: ['Delivery Approach', 'Resource Planning', 'Schedule', 'Ship', 'Deliver', 'Install']
    },
    {
        id: 'accounting',
        name: 'Accounting',
        subLabels: ['Invoice', 'Processing', 'Posting']
    },
    {
        id: 'cx',
        name: 'Customer Experience',
        subLabels: ['Journey Map', 'Execute', 'Evolve']
    },
    {
        id: 'marketing',
        name: 'Future Marketing Churn or Upsell',
        subLabels: ['Plan', 'Execute', 'Evolve']
    },
];

export const INITIAL_COMPANIES = [
    { id: 'c1', name: 'Acme Corp', revenue: 1200000, stageId: 'sales', subStageId: 'Decision', description: 'Enterprise contract renewal', lastContact: '2 days ago', color: 'green' },
    { id: 'c2', name: 'Globex', revenue: 450000, stageId: 'sales', subStageId: 'Interest', description: 'Interested in Q3 implementation', lastContact: '1 week ago', color: 'blue' },
    { id: 'c3', name: 'Soylent Corp', revenue: 85000, stageId: 'sales', subStageId: 'Lead Awareness', description: 'Inbound lead from webinar', lastContact: 'Yesterday', color: 'red' },
    { id: 'c4', name: 'Initech', revenue: 2500000, stageId: 'delivery', subStageId: 'Resource Planning', description: 'Full suite upgrade', lastContact: '3 days ago', color: 'yellow' },
    { id: 'c5', name: 'Umbrella Corp', revenue: 5000000, stageId: 'delivery', subStageId: 'Install', description: 'Global license agreement', lastContact: 'Today', color: 'orange' },
    { id: 'c6', name: 'Stark Ind', revenue: 15000000, stageId: 'accounting', subStageId: 'Invoice', description: 'Multi-year defense contract', lastContact: '1 month ago', color: 'teal' },
    { id: 'c7', name: 'Wayne Ent', revenue: 8000000, stageId: 'marketing', subStageId: 'Plan', description: 'Potential merger acquisition', lastContact: '2 days ago', color: 'green' },
    { id: 'c8', name: 'Cyberdyne', revenue: 300000, stageId: 'cx', subStageId: 'Journey Map', description: 'AI research partnership', lastContact: '5 days ago', color: 'blue' },
    { id: 'c9', name: 'Massive Dynamic', revenue: 600000, stageId: 'cx', subStageId: 'Execute', description: 'Biotech lab equipment', lastContact: '1 day ago', color: 'red' },
    { id: 'c10', name: 'Hooli', revenue: 120000, stageId: 'sales', subStageId: 'Expand', description: 'Compression algorithm licensing', lastContact: '3 weeks ago', color: 'orange' },
    { id: 'c11', name: 'Pied Piper', revenue: 950000, stageId: 'marketing', subStageId: 'Evolve', description: 'Middle-out compression deals', lastContact: '2 weeks ago', color: 'teal' },
    { id: 'c12', name: 'Aperture Sci', revenue: 2200000, stageId: 'delivery', subStageId: 'Ship', description: 'Portal technology', lastContact: 'Yesterday', color: 'yellow' },
    { id: 'c13', name: 'Black Mesa', revenue: 3100000, stageId: 'accounting', subStageId: 'Posting', description: 'Government grant', lastContact: 'Today', color: 'green' },
    { id: 'c14', name: 'Tyrell Corp', revenue: 4200000, stageId: 'marketing', subStageId: 'Execute', description: 'Replicant program', lastContact: '3 days ago', color: 'red' },
    { id: 'c15', name: 'Oscorp', revenue: 1100000, stageId: 'sales', subStageId: 'Action', description: 'Genetic research', lastContact: '4 days ago', color: 'blue' },
];